import { buildParticipantMap } from '../participant'
import { type ParticipantWithSeed, type TinyBracketGame } from './displayRounds'
import { type DecoratedGameParticipant, type GameParticipantId, generateBracket, getNumOfPlayers } from '@terros/common'

export function decorateSeeding(
  participants: DecoratedGameParticipant[],
  game: TinyBracketGame
): ParticipantWithSeed[] {
  const participantMap = buildParticipantMap(participants)
  const participantsWithSeed = new Map<GameParticipantId, ParticipantWithSeed>()

  const numPlayers = getNumOfPlayers(participants.length, game.settings.bracketSize)
  const bracket = generateBracket(numPlayers)

  const initialRound = game.rounds.find((round) => round.round === 1)
  if (!initialRound) return participants

  const roundMatches = bracket.get(initialRound.round)

  const setSeed = (participantId: GameParticipantId | undefined, seed: number): void => {
    if (!participantId) return
    const participant = participantMap.get(participantId)
    if (!participant) return
    participantsWithSeed.set(participantId, {
      ...participant,
      seed,
    })
  }

  for (const match of initialRound.matches) {
    const seedMatch = roundMatches?.find((m) => m.id === match.id)
    if (!seedMatch) continue
    setSeed(match.participant1, seedMatch.player1)
    setSeed(match.participant2, seedMatch.player2)
  }

  return Array.from(participantsWithSeed.values())
}
